/* Pyramid Cotton — shows the original price and the offer name on discounted cart lines.
   The cart drawer is re-rendered by theme.js; this decorates each line from /cart.js. */
(function () {
  var body = document.querySelector('.cart-drawer__body');
  if (!body) return;
  var money = function (cents) {
    var fmt = (window.pyramidTheme && window.pyramidTheme.moneyFormat) || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };
  var busy = false;
  function decorate() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cart.items.forEach(function (item) {
          var row = body.querySelector('.cart-item[data-key="' + item.key + '"]');
          if (!row) return;
          var price = row.querySelector('.cart-item__price');
          if (price && item.original_line_price > item.final_line_price && !price.querySelector('.cart-item__was')) {
            price.innerHTML = '<s class="cart-item__was">' + money(item.original_line_price) + '</s> ' + money(item.final_line_price);
          }
          var allocs = (item.line_level_discount_allocations || []).filter(function (a) { return a.amount > 0; });
          if (allocs.length && !row.querySelector('.cart-item__offer')) {
            var label = document.createElement('span');
            label.className = 'cart-item__offer';
            label.textContent = (allocs[0].discount_application && allocs[0].discount_application.title) || 'Offer applied';
            var anchor = row.querySelector('.cart-item__variant') || row.querySelector('.cart-item__title');
            if (anchor) anchor.insertAdjacentElement('afterend', label);
          }
        });
      })
      .catch(function () {})
      .then(function () { setTimeout(function () { busy = false; }, 150); });
  }
  new MutationObserver(function () { decorate(); }).observe(body, { childList: true });
})();
